import { render, staticRenderFns } from "./editpwd.vue?vue&type=template&id=2188a2e0&"
import script from "./editpwd.vue?vue&type=script&lang=js&"
export * from "./editpwd.vue?vue&type=script&lang=js&"
import style0 from "./editpwd.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports